import {EnumTranslator} from '../Models/enum/enumTranslator';
import {FieldType} from '../Models/enum/fieldType';
import {DateExibitionFormat} from '../Models/enum/dateExibitionFormat';
import {FieldDomainType} from '../Models/enum/fieldDomainType';
import {FieldValidator} from '../Models/enum/fieldValidator';
import {FieldMaskType} from '../Models/enum/fieldMaskType';
import {NodeConfigurationType} from '../Models/enum/nodeConfigurationType';
import {MetadataType} from '../Models/enum/metadataType';
import {MetadataEditingType} from '../Models/enum/metadataEditingType';
import {DataExtractionType} from '../Models/enum/dataExtractionType';
import {DataExtractionIntervalType} from '../Models/enum/dataExtractionIntervalType';
import {TaskLogStatus} from '../Models/enum/taskLogStatus';


export class EnumTranslateService {
  static getFieldTypeEnumTranslated(fieldType) {
    return EnumTranslator.getEnumValueTranslated(FieldType[fieldType]);
  }

  static getEnumDateType(dateType) {
    return EnumTranslator.getEnumDateType(DateExibitionFormat[dateType]);
  }

  static getEnumFieldDomainType(domainType) {
    return EnumTranslator.getEnumFieldDomainType(FieldDomainType[domainType]);
  }

  static getEnumFieldValidator (fieldValidatorType) {
    return EnumTranslator.getEnumFieldValidator(FieldValidator[fieldValidatorType]);
  }

  static getEnumMaskType (maskType) {
    return EnumTranslator.getEnumMaskType(FieldMaskType[maskType]);
  }

  static getEnumNodeType (nodeType) {
    return EnumTranslator.getEnumNodeType(NodeConfigurationType[nodeType]);
  }

  static getEnumMetadataType (metadataType) {
    return EnumTranslator.getEnumMetadataType(MetadataType[metadataType]);
  }

  static getEnumMetadataEditingType (metadataEditingType) {
    return EnumTranslator.getEnumMetadataEditingType(MetadataEditingType[metadataEditingType]);
  }

  static getEnumDataExtractionType (dataExtractionType) {
    return EnumTranslator.getEnumDataExtractionType(DataExtractionType[dataExtractionType]);
  }

  static getEnumDataExtractionIntervalType (dataExtractionIntervalType) {
    return EnumTranslator.getEnumDataExtractionIntervalType(DataExtractionIntervalType[dataExtractionIntervalType]);
  }

  static getEnumTaskLogStatus (taskLogStatusType) {
    return EnumTranslator.getEnumTaskLogStatus(TaskLogStatus[taskLogStatusType]);
  }
}
